import React from 'react';

const PUBLIC = process.env.PUBLIC_URL || '';

/**
 * The official Zaptude brand mark (client/public/branding/zaptude-mark.svg — the exact supplied asset,
 * never redrawn). Used everywhere the brand appears at icon size: student + admin headers, Login.
 */
export default function ZapMark({ size = 32, className = '' }) {
  return (
    <img
      className={className}
      src={`${PUBLIC}/branding/zaptude-mark.svg`}
      width={size}
      height={size}
      alt="Zaptude"
      draggable={false}
    />
  );
}
